import React, { useEffect, useState } from 'react'
import Skills from "../../Components/Skills/Skills";


const SkillsPage = () => {
    const [data, setData] = useState(null);

    const getData = () => {
    fetch('settings.json'
        , {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
        }
    ).then(function(response){
        return response.json();
    })
    .then(function(myJson) {
        console.log(myJson)
        setData(myJson.Components);
    });
    }
    useEffect(() => {
    getData()
    }, [])


    return (
        <div style={{paddingTop: "2rem"}}>
            {data && console.log(data)}
        {
            data && <Skills props={data.Skills}/>
        }            
        </div>
    )
}

export default SkillsPage
